import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ScheduleCalendarContent with_white_bg ofs",
  style: {"margin-top":"30px","padding":"0","min-height":"auto"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "w100 pad20 fw600 llgreyBg",
  style: {"height":"100px"}
}
const _hoisted_4 = {
  key: 1,
  style: {"line-height":"23px"},
  class: "fl mt10 ml15"
}
const _hoisted_5 = { class: "fs12 ddgrey fw600" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "fs18 fw600 ddgrey" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ml10" }, "からのメモ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  class: "fs13 kaigyo rad8 mt5",
  style: {"padding":"36px 30px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "w100 pad20 fw600",
  style: {"height":"100px"}
}
const _hoisted_13 = {
  key: 2,
  class: "pad40"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_ThanksPage = _resolveComponent("ThanksPage")!

  return (_ctx.rm.currentRoom && (!_ctx.isSP || _ctx.showThanksPage || _ctx.showOutOfDateContent))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.isSP && _ctx.rm.currentRoom.current_appointment.memo && !_ctx.Util.isPublic())
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.rm.currentRoom.owner)
                  ? (_openBlock(), _createBlock(_component_UserIcon, {
                      key: 0,
                      width: 62,
                      canEdit: false,
                      member: _ctx.rm.currentRoom.owner,
                      class: "fl"
                    }, null, 8, ["member"]))
                  : _createCommentVNode("", true),
                (_ctx.rm.currentRoom.owner)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.rm.currentRoom.owner.company_name ? _ctx.rm.currentRoom.owner.company_name : ` `), 1),
                      _hoisted_6,
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.rm.currentRoom.owner.name), 1),
                      _hoisted_8
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_ctx.rm.currentRoom.current_appointment.memo), 1)
              ]),
              _hoisted_11
            ]))
          : (_ctx.showOutOfDateContent)
            ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(_ctx.outOfTimeMessage), 1)
              ]))
            : (_ctx.showThanksPage)
              ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                  _createVNode(_component_ThanksPage, {
                    room: _ctx.rm.currentRoom
                  }, null, 8, ["room"])
                ]))
              : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}